import { action, observable } from 'mobx';
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';
import stores from "cd-eft/models/Stores";
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';

interface waterwayComment {
    projectUuid: string,
    commentAuthor: string,
    projectComment: string,
    createdBy: string,
    creationDateUtc: number,
    lastChangedBy: string,
    projectElementCommentId: number,
    commentTypeId?: number,
    designElementId?: number,
    designTypeAndStructureName?: string,
    editStatus?: string,
    lastChangeDateUtc?: number,
    deleted?: number,
    status?: string,
    index?: number,
    commentStatus: 'getFromAPI' | 'add' | 'delete' | 'edit' | '' // delete and edit are only applied to the comments populated by API call, not applied to temperary added comments
    //More explaination: Since we are saving either comments from calling GET API or comments from using munually entered by users. if the status is getFromAPI, it can be changed to delete or edit. If the status is add, no matter it is deleted or edited, the status will be add always

}

interface projectElementCommentDtoJson {
    commentAuthor: string,
    commentTypeId: 2, // 2 is design comment
    designElementId: 7, // 7 is waterway 
    designTypeAndStructureName: string,
    editStatus: string, // --- this attribute is not in interface waterwayComment
    projectComment: string,
    projectUuid: string
}



const designStore = stores.AppStore.designStore;
const waterwayDesignStore = stores.AppStore.waterwayDesignStore;

export class WaterwayCommentsVM {
    @observable logginUser: string = localStorage['username'];
    @observable checkedState: boolean[] = [];
    @observable waterwayCommentdata: waterwayComment[] = [];
    @observable newWaterwayCommentsStore: waterwayComment[] = [];
    @observable summarizedWaterwayCommentsStore: waterwayComment[] = [];
    @observable deletedWaterwayComments: waterwayComment[] = [];
    @observable newWaterwayComment: waterwayComment = {
        projectUuid: designStore.projectsStore.currentProject.projectUuid,
        projectComment: '',
        commentAuthor: this.logginUser,
        createdBy: this.logginUser,
        creationDateUtc: 0,
        lastChangedBy: '',
        index: -1,
        commentStatus: '',
        projectElementCommentId: -1
    };
    @observable editedWaterwayComment = {
        projectComment: '',
        commentStatus: ''
    };
    @observable elementActions = {
        Edit: { action: this.toggleEditFormVisible },
        Delete: { action: this.toggleDeleteFormVisible },
        Add: { action: this.toggleAddFormVisible },
    };
    @observable rowHeight: any;
    @observable readOnlyForm = true;
    @observable addFormVisible = false;
    @observable editFormBtnVisible = false;
    @observable editFormVisible = false;
    @observable cancelButton = false;
    @observable deleteFormBtnVisible = false;
    @observable deleteFormVisible = false;
    @observable deletePopup = false
    @observable targetId = '';

    @action.bound handleInput(event) {
        event.preventDefault();
        const { name, value } = event.target;
        this.newWaterwayComment.projectComment = value;
        const numline = event.target.value.split(/\r\n|\r|\n/).length + 1;
        this.rowHeight = numline;
    }

    @action.bound handleEditCheckBox(position) {
        this.checkedState = this.checkedState.map((item, index) =>
            index === position ? !item : false
        );
        this.editedWaterwayComment.projectComment = this.summarizedWaterwayCommentsStore[position].projectComment;
    }

    @action.bound handleEditInputChange(event, position) {
        event.preventDefault();
        const { name, value } = event.target;
        this.editedWaterwayComment.projectComment = value;
    }

    @action.bound handleEditCancelButton(position) {
        this.editedWaterwayComment.projectComment = this.summarizedWaterwayCommentsStore[position].projectComment;
        this.checkedState[position] = false;

    }

    @action.bound handleEditSaveButton(position) {
        this.summarizedWaterwayCommentsStore[position].projectComment = this.editedWaterwayComment.projectComment;
        if (this.summarizedWaterwayCommentsStore[position].commentStatus === 'getFromAPI') {
            this.summarizedWaterwayCommentsStore[position].commentStatus = 'edit';
        }
        this.readOnlyForm = true;
        this.editFormVisible = false;
        this.checkedState[position] = false;

    }

    @action.bound handleDeleteCheckBox(position) {
        this.checkedState = this.checkedState.map((item, index) =>
            index === position ? !item : item
        );
    }

    @action.bound async getComments() {
        if (designStore.projectsStore.currentProject.projectUuid && waterwayDesignStore.alignedDesignElementId !== 0) {
            try {
                const response: any = await PRJAPI.ProjectElementCommentController.getProjectElementCommentsByProjectUuidUsingGET(designStore.projectsStore.currentProject.projectUuid);
                if (response.data && response.data.length > 0) {
                    // since the comment type is not known yet, using attribute designTypeAndStructureName to filter out waterway comments  
                    this.waterwayCommentdata = response.data.filter(data => data.designTypeAndStructureName.toLowerCase().split(',')[0].includes('waterway') && data.designElementId === waterwayDesignStore.alignedDesignElementId);
                    this.summarizedWaterwayCommentsStore = this.waterwayCommentdata.map(
                        (element, index) => {
                            return {
                                // deep copy the data retrieved from API
                                commentAuthor: element.commentAuthor,
                                commentTypeId: element.commentTypeId,
                                createdBy: element.createdBy,
                                creationDateUtc: element.creationDateUtc,
                                deleted: element.deleted,
                                designElementId: element.designElementId,
                                designTypeAndStructureName: element.designTypeAndStructureName,
                                editStatus: element.editStatus,
                                lastChangeDateUtc: element.lastChangeDateUtc,
                                lastChangedBy: element.lastChangedBy,
                                projectComment: element.projectComment,
                                projectElementCommentId: element.projectElementCommentId,
                                projectUuid: element.projectUuid,
                                status: element.status,
                                // add index and status to be used in the display 
                                index: index,
                                commentStatus: 'getFromAPI'
                            }

                        }
                    )
                }
            }
            catch (error) {
                MessageCenter.addError((error as Error).message);
            }
        }
    }

    @action.bound toggleEditFormVisible() {
        this.editFormVisible = !this.editFormVisible;
        this.readOnlyForm = !this.readOnlyForm;
        this.addFormVisible = false;
        this.deleteFormVisible = false;
        this.checkedState = new Array(this.summarizedWaterwayCommentsStore.length).fill(false)
    }

    @action.bound toggleDeleteFormVisible() {
        this.deleteFormBtnVisible = !this.deleteFormBtnVisible;
        this.deleteFormVisible = !this.deleteFormVisible;
        this.cancelButton = false;
        this.addFormVisible = false
        this.editFormVisible = false;
        this.readOnlyForm = true;
        this.checkedState = new Array(this.summarizedWaterwayCommentsStore.length).fill(false)
    }
    @action.bound toggleAddFormVisible() {
        this.addFormVisible = !this.addFormVisible;
        this.editFormBtnVisible = false;
        this.editFormVisible = false;
        this.cancelButton = false;
        this.deleteFormBtnVisible = false;
        this.deleteFormVisible = false;
        this.readOnlyForm = true;
        this.targetId = '';
    }

    @action.bound cancelWaterwayComment() {
        this.readOnlyForm = true;
        this.addFormVisible = false;
        this.editFormVisible = false;
        this.editFormBtnVisible = false;
        this.cancelButton = false;
        this.deleteFormBtnVisible = false;
        this.deleteFormVisible = false;
        this.targetId = '';
        this.rowHeight = ''
        // reset newWaterwayComment
        this.resetNewwaterwayComment()

    };

    @action.bound cancelComment() {
        this.cancelWaterwayComment();
        this.checkedState = this.checkedState.map(e => false);
        this.deletePopup = false;
    }
    @action.bound toggleDeletePopup() {
        this.deletePopup = true;
    }
    @action.bound addWaterwayComment() {
        if (!this.newWaterwayComment.projectComment) {
            this.addFormVisible = false;
            return
        }
        const currentDate = new Date();
        this.newWaterwayComment.creationDateUtc = currentDate.getTime();
        this.newWaterwayComment.lastChangeDateUtc = currentDate.getTime();
        this.newWaterwayComment.lastChangedBy = this.logginUser;
        this.newWaterwayComment.index = this.newWaterwayCommentsStore.length;
        this.newWaterwayComment.commentStatus = 'add';
        this.newWaterwayCommentsStore.push(JSON.parse(JSON.stringify(this.newWaterwayComment)));
        this.summarizedWaterwayCommentsStore.unshift(JSON.parse(JSON.stringify(this.newWaterwayComment)));
        // reset this.newWaterwayComment after push it to this.newWaterwayCommentsStore
        this.resetNewwaterwayComment()

        this.addFormVisible = false;
    }

    @action.bound resetNewwaterwayComment() {
        this.newWaterwayComment.projectUuid = designStore.projectsStore.currentProject.projectUuid;
        this.newWaterwayComment.projectComment = '';
        this.newWaterwayComment.commentAuthor = this.logginUser;
        this.newWaterwayComment.createdBy = this.logginUser;
        this.newWaterwayComment.creationDateUtc = 0;
        this.newWaterwayComment.lastChangedBy = '';
        this.newWaterwayComment.index = -1;
        this.newWaterwayComment.commentStatus = '';
    }

    @action.bound handleDeleteComments() {
        this.deletedWaterwayComments.push(...this.summarizedWaterwayCommentsStore.filter((comment, index) => this.checkedState[index] === true && comment.commentStatus !== 'add'));
        this.summarizedWaterwayCommentsStore = this.summarizedWaterwayCommentsStore.filter((comment, index) => this.checkedState[index] === false);
        this.cancelWaterwayComment();
        this.checkedState = this.checkedState.map(e => false);
        this.deletePopup = false;
    }

    @action.bound async PostNewComments(designElementId, designTypeAndStructureName) {
        if (designStore.projectsStore.currentProject.projectUuid) {
            await Promise.all(this.summarizedWaterwayCommentsStore.filter(data => data.commentStatus.includes('add')).map(
                async (element) => {
                    const structurePostJSON: projectElementCommentDtoJson = {
                        commentAuthor: this.logginUser,
                        commentTypeId: 2,
                        designElementId: designElementId,
                        designTypeAndStructureName: `Waterway: ${designTypeAndStructureName}`,
                        editStatus: 'add',
                        projectComment: element.projectComment,
                        projectUuid: element.projectUuid
                    }
                    try {
                        const response = await PRJAPI.ProjectElementCommentController.createProjectElementCommentByProjectUuidUsingPOST(structurePostJSON)
                        if (response.data) {
                            this.resetNewwaterwayComment();
                        }
                    } catch (error) {
                        MessageCenter.addError((error as Error).message);
                    }
                }
            )
            )
        }
    }

    @action.bound async DeleteComments() {
        if (designStore.projectsStore.currentProject.projectUuid && this.deletedWaterwayComments.length > 0) {
            const postJSON = {
                projectElementCommentIdList: this.deletedWaterwayComments.map((comment) => comment.projectElementCommentId),
                projectUuid: designStore.projectsStore.currentProject.projectUuid
            };
            try {
                const response = await PRJAPI.ProjectElementCommentController.deleteProjectElementCommentsByProjectElementCommentIdsUsingPOST(postJSON)
                if (response.data) {
                    this.resetNewwaterwayComment();
                    this.deletedWaterwayComments = [];
                }
            } catch (error) {
                MessageCenter.addError((error as Error).message);
            }

        }
    }

    @action.bound async EditComments() {
        if (designStore.projectsStore.currentProject.projectUuid && this.summarizedWaterwayCommentsStore.filter(comment => comment.commentStatus === 'edit')) {
            await Promise.all(this.summarizedWaterwayCommentsStore.filter(data => data.commentStatus.includes('edit')).map(
                async (element) => {
                    const postJSON = {
                        projectUuid: element.projectUuid,
                        commentTypeId: 2,
                        projectElementCommentId: element.projectElementCommentId,
                        designElementId: element.designElementId,
                        designTypeAndStructureName: element.designTypeAndStructureName,
                        commentAuthor: this.logginUser,
                        projectComment: element.projectComment,
                        editStatus: 'update'
                    };
                    try {
                        const response = await PRJAPI.ProjectElementCommentController.editProjectElementCommentByProjectElementCommentIdUsingPOST(postJSON)
                        if (response.data) {
                            this.resetNewwaterwayComment();
                        }
                    } catch (error) {
                        MessageCenter.addError((error as Error).message);
                    }
                }
            )
            )
        }
    }
    @action.bound async handleCommentSubmit(designElementId, designTypeAndStructureName) {
        await this.PostNewComments(designElementId, designTypeAndStructureName);
        await this.EditComments();
        await this.DeleteComments();
        await this.getComments();
    }
}